<template>
	<div>
		<b-modal v-model="ShowBkashNameMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the bkash account.
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					Receiver's Name : {{BkashReceiverName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNo">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYes">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowWingWalletCurrencyMismatchPopup" ref="modal-wingwalletmismatch" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver currency doesn't match the details of the
					registered to the Wing Wallet number.
				</p>
				<p>
					Wing Wallet Account Name : {{WingWalletFullName}} <br>
					Wing Wallet Currency : {{WingWalletCurrency}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleClose">Close</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<b-modal v-model="ShowIndonesiaAccountMismatchPopup" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
				 no-close-on-esc='true' centered hide-header hide-footer>
			<template v-slot:default="">
				<p>
					The receiver name you entered doesn't match the details
					registered to the Indonesia Bank account.
				</p>
				<p>
					Would you like to update the receiver name to the following?
				</p>
				<p>
					Receiver's Name : {{IndonesiaAccountReceiverName}}
				</p>

				<br />
				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleNoForIndonesiaAcc">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleYesForIndonesiaAcc">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>
		<!--<OnBehalfPopup :vModel="onbehalfRelatedModel"></OnBehalfPopup>-->
		<b-modal v-model="ShowReceiverTypePopup" class="modal-validation" size="md" no-close-on-backdrop="true" no-close-on-esc="true" centered hide-header hide-footer>
			<template v-slot:default>
				<p>
					The entered receiver name appears to be a business name.
				</p>

				<p>
					Would you like to change the receiver type to Business?
				</p>

				<br />

				<div class="popup-onbehalf-button-wrapper">
					<span>
						<b-button class="button-left" variant="danger" @click="handleReceiverTypeNo">NO</b-button>
						<b-button class="button-right" variant="success" @click="handleReceiverTypeYes">YES</b-button>
					</span>
				</div>
			</template>
		</b-modal>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">{{mode=="add" ? "Create New" : "Edit"}} Recipient</h2>
			</div>
		</div>
		<div v-if="onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList" class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
					<OnBehalfDetail :vModel="onbehalfRelatedModel"></OnBehalfDetail>
				</div>

			</div>
		</div>
		<div v-else class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt class="top-indicator" />
					<form @submit.prevent="onSubmit" novalidate>
						<div class="form-card">
							<div class="form-card-header">
								<h3>Payment Details</h3>
								<img src="/static/img/eremit-logo.png" />
							</div>
							<div class="form-card-forms">
								<div v-if="mode != 'edit'">
									<div v-show="isOnSecondPage == false && vModel.Id == null">
										<div class="row">
											<div class="col-lg-4">
												<div class="form-group">
													<label for>
														Country
														<span class="required">*</span>
													</label>
													<div class="input-group mb-3">
														<kendo-dropdownlist v-if="CountryCollection != null" name="CountryId" id="CountryId"
																			class="form-control" :class="{'input': true, 'is-danger': errors.has('CountryId') }"
																			v-validate="'required'" ref="countrydropdownlist" v-model="vModel.CountryId"
																			:data-text-field="'Text'" :data-value-field="'Id'" data-vv-as="Country"
																			:option-label="'Please Select Country'" :auto-bind="true" :data-source="CountryCollection"
																			:data-value-primitive="true" @change="onChangeCountryDropDown"></kendo-dropdownlist>
														<div v-show="errors.has('CountryId')" class="help is-danger">
															{{ errors.first('CountryId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4">
												<div class="form-group">
													<label for>
														Payment Mode
														<span class="required">*</span>
													</label>
													<div class="input-group mb-3">
														<kendo-dropdownlist name="PayMode" v-validate="'required'" class="form-control"
																			data-vv-as="Payment mode" :class="{'input': true, 'is-danger': errors.has('PayMode') }"
																			v-model="vModel.PayoutModeId" :data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Payment Mode'" :auto-bind="true" :index="0"
																			:data-value-primitive="true" ref="paymodedropdownlist" @change="onPaymentModeChange">
														</kendo-dropdownlist>
														<div v-show="errors.has('PayMode')" class="help is-danger">
															{{ errors.first('PayMode') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4"></div>
										</div>
									</div>
								</div>
								<div v-if="isOnSecondPage">
									<div class="row">
										<div class="col-sm-4">
											<div class="form-group">
												<label for>Country</label>
												<div class="input-group mb-3">
													<img :src="'/static/img/flags/'+(FlagCode == null ? vModel.FlagCode: FlagCode)+'.png'"
														 class="mr-1" style="margin-top:-12px;" />
													{{vModel.CountryName}}
												</div>
											</div>
										</div>
										<div class="col-sm-4">
											<div class="form-group">
												<label for>Payment Mode</label>
												<div class="input-group mb-3">{{vModel.PayModeName}}</div>
											</div>
										</div>
										<div class="col-md-4" v-if="vModel.CountryName == 'China' && vModel.PayoutModeId == 21">
											<div class="form-group">
												<label for="">
													Payout Name
												</label>
												<!--<div class="input-group mb-3">
												{{vModel.PayoutGroupName}}
											</div>-->
												<div class="mb-3">
													<kendo-dropdownlist name='AgentId' v-if="PayoutGroupCollection!=null" class="form-control" @change="onChangePayoutGroup" data-vv-as='Payout Name'
																		v-model="vModel.AgentId" :data-text-field="'Text'" :data-value-field="'Id'" ref="payoutagentdropdownlist"
																		:option-label="'Please Select Payout Name'" :auto-bind="true" :data-source="PayoutGroupCollection"
																		:data-value-primitive="true">
													</kendo-dropdownlist>
													<input type="hidden" v-model="vModel.AgentId"
														   v-validate="'required'" data-vv-as="Payout Name"
														   id="AgentId" name="AgentId" />
													<div v-show="errors.has('AgentId')" class="help is-danger">
														{{ errors.first('AgentId') }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- eo form card forms -->
						</div>
						<!-- eo form card -->
						<div class="submit-option" v-if="isOnSecondPage == false && vModel.Id == null">
							<div class="left-option">
								<button class="btn submit-lefticon-btn" @click="onCancel()" type="button">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</button>
							</div>
							<div class="right-option">
								<button class="btn submit-righticon-btn">
									<span class="btn-content">Next</span>
									<span class="right-icon">
										<i class="material-icons">chevron_right</i>
									</span>
								</button>
							</div>
						</div>
						<div>
							<div class="form-card" v-if="vModel.PayoutModeId == 1 || vModel.PayoutModeId == 24 || vModel.PayoutModeId == 25||vModel.PayoutModeId==27 ||vModel.PayoutModeId==28 ||vModel.PayoutModeId==29">
								<div class="form-card-header">
									<h3>{{ (vModel.PayoutModeId == 24 ||vModel.PayoutModeId == 28 ||vModel.PayoutModeId == 29 ) ? "eWallet Number Details" : "Bank Details"}}</h3>
								</div>
								<div class="form-card-forms">
									<!-- For India Only -->
									<div class="shaded-section" v-if="vModel.CountryId==2">
										<div class="row">
											<div class="col-sm-4" v-if="FieldValidation != null && FieldValidation.BankId != null">
												<div class="form-group">
													<label>
														{{vModel.PayoutModeId == 24 ? "eWallet Type" : "Bank Name"}}
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="BankCollection != null" name="BankId"
																		:data-vv-as="FieldValidation.BankId.WebRequiredMessage" v-validate="'required'"
																		class="form-control" :class="{'input': true, 'is-danger': errors.has('BankId') }"
																		ref="bankdropdownlist" v-model="vModel.BankId" :data-text-field="'Text'"
																		:data-value-field="'Id'" :option-label="'Please Select Bank'" :auto-bind="true"
																		:filter="'startswith'" :data-source="BankCollection" :data-value-primitive="true"
																		@change="onChangeBankDropDown"></kendo-dropdownlist>
													<div v-show="errors.has('BankId')" class="help is-danger">{{ errors.first('BankId') }}</div>
												</div>
											</div>

											<!-- <div class="col-sm-2 text-center">
													  <label>
													  <strong>(Or)</strong>
													  </label>
										</div>-->
											<div class="col-sm-8"
												 v-if="FieldValidation != null && FieldValidation.IFSC != null && vModel.CountryId == 2">
												<div class="form-group">
													<div class="row">
														<div class="col-sm-6">
															<label>
																Bank's IFSC
																<span class="required">*</span>
															</label>
															<input type="text" class="form-control" id="name" name="IFSC" autocomplete="off"
																   v-model="vModel.IFSC" :data-vv-as="FieldValidation.IFSC.WebRequiredMessage"
																   v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('IFSC') }"
																   v-only-uppercase />
															<div v-show="errors.has('IFSC')" class="help is-danger">{{ errors.first('IFSC') }}</div>
														</div>
														<div class="col-sm-12">
															<div>
																<small>
																	The Indian Financial System Code (IFSC Code)
																	is a code of 11 numbers and letters that
																	uniquely identifies the bank branch.
																</small>
															</div>
															<div>
																<a href="http://www.ifsccodebank.com/" target="_blank" style="color: red">
																	Don't
																	know the IFSC Code?
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<!-- <div class="row">
												 <div class="col-sm-4">
													<div class="form-group">
													   <label>
													   Branch
													   <span class="required">*</span>
													   </label>
													   <v-select :data-vv-as='Branch' name="vSelectBranchId" label="Text" :filterable="false" v-validate="'required'" :options="optionBranches"
														  @search="onSearch" v-model="selectedBranch" placeholder="Select Branch" :class="{'input': true, 'bank-branch':true, 'is-danger': errors.has('vSelectBranchId') }">
														  <template slot="no-options">
															 Please enter your branch name
														  </template>
													   </v-select>
													   <div v-show="errors.has('vSelectBranchId')" class="help is-danger">{{ errors.first('vSelectBranchId') }}</div>
									</div>-->
										<!-- </div> -->
										<!-- <div class="col-sm-2"></div>
												 <div class="col-sm-4">
													<div class="form-group">
													   <label>Address:</label>
													   <div class="clearfix"></div>
													   <div>{{vModel.Address}}</div>
													</div>
									</div>-->
										<!-- </div> -->
									</div>
									<div class="shaded-section">
										<div class="row">
											<div class="col-sm-4" v-if="FieldValidation!=null && FieldValidation.ReceiverTypeId != null">
												<div class="form-group">
													<label>
														Receiver Type
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="ReceiverTypeCollection != null"
																		name='ReceiverType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('ReceiverType') }"
																		ref="receivertypedropdownlist" v-model="vModel.ReceiverTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Receiver Type'" :auto-bind="true"
																		:data-source="ReceiverTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'"
																		:data-vv-as='FieldValidation.ReceiverTypeId.WebRequiredMessage'
																		@dataBound="onReceiverTypeDropDownBound"
																		@change="onChangeReceiverType">
													</kendo-dropdownlist>
													<div v-show="errors.has('ReceiverType')" class="help is-danger">
														{{ errors.first('ReceiverType') }}
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- India End -->
									<!-- <div class="shaded-section" v-if="vModel.CountryId !=2  && vModel.CountryId !=56"> -->
									<div class="shaded-section" v-if="vModel.CountryId !=2">
										<div class="row">
											<div class="col-sm-4"
												 v-if="FieldValidation != null && FieldValidation.WalletTypeId != null && (vModel.PayoutModeId == 28 || (vModel.PayoutModeId == 29 && vModel.CountryId == 10))">
												<div class="form-group">
													<label>
														eWallet Type <span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="WalletTypeCollection != null"
																		name='WalletTypeId' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('WalletTypeId') }"
																		ref="wallettypelist" v-model="vModel.WalletTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select eWallet Type'" :auto-bind="true"
																		:data-source="WalletTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'"
																		:data-vv-as='FieldValidation.WalletTypeId.WebRequiredMessage'
																		@dataBound="onBankDropDownBound">
													</kendo-dropdownlist>
													<div v-show="errors.has('WalletTypeId')" class="help is-danger">
														{{ errors.first('WalletTypeId') }}
													</div>
												</div>
											</div>
											<div class="col-sm-4" v-if="FieldValidation != null && FieldValidation.BankId != null">
												<div class="form-group">
													<label>
														{{vModel.PayoutModeId == 24 ? "eWallet Type" : "Bank Name"}}
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="BankCollection != null" name="BankId" v-validate="'required'"
																		class="form-control" :class="{'input': true, 'is-danger': errors.has('BankId') }"
																		ref="bankdropdownlist" v-model="vModel.BankId" :data-text-field="'Text'"
																		:data-value-field="'Id'" :option-label="'Please Select Bank'" :auto-bind="true"
																		:data-source="BankCollection" :data-value-primitive="true" :filter="'startswith'"
																		@change="onChangeBankDropDown" :data-vv-as="FieldValidation.BankId.WebRequiredMessage"
																		@dataBound="onBankDropDownBound"></kendo-dropdownlist>
													<div v-show="errors.has('BankId')" class="help is-danger">{{ errors.first('BankId') }}</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && (vModel.PayoutModeId == 24  || vModel.PayoutModeId == 27   || vModel.PayoutModeId == 28 || vModel.PayoutModeId == 29)">
												<div class="form-group">
													<div>
														<label>
															{{vModel.PayoutModeId==27?'Wallet Number':'eWallet Number'}}
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<div v-if="vModel.PayoutModeId==27" class="input-group-prepend"><span class="input-group-text" style="color:#000;"><span>+ </span></span></div>
														<div class="input-group-prepend" v-if="FieldValidation != null && FieldValidation.AccountPrefix != null && IsPrefixAvaliable">
															<kendo-dropdownlist name='AccountPrefix' v-validate="'required'"
																				class="form-control"
																				:class="{'input': true, 'is-danger': errors.has('AccountPrefix') }"
																				ref="AccountPrefix" v-model="vModel.AccountPrefix"
																				:data-text-field="'Text'" :data-value-field="'Text'"
																				:auto-bind="true"
																				:data-source="AccountPrefix"
																				:data-value-primitive="true"
																				:data-vv-as='required'
																				@dataBound="onBankDropDownBound">
															</kendo-dropdownlist>

															<div v-show="errors.has('AccountPrefix')" class="help is-danger">
																{{ errors.first('AccountPrefix') }}
															</div>
														</div>
														<div class="input-group-prepend" v-show="showGcashAccountPrefix">
															<span class="input-group-text">09</span>
														</div>
														<input type="text" class="form-control" name="AccountNumber"
															   v-validate="this.vModel.PayoutModeId==28 ? {required: true, regex: '^[a-zA-Z0-9]*$'} : {required: true,regex:'^[0-9]*$'}"
															   autocomplete="off" v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   maxlength="20"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber'),'ml-5':IsPrefixAvaliable  }">
													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>
												</div>
											</div>

											<div class="col-sm-4" v-if="FieldValidation != null && FieldValidation.BranchId != null">
												<div class="form-group">
													<label>
														Branch
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist name="Branch" v-validate="'required'" class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('Branch') }"
																		:data-vv-as="FieldValidation.BranchId.WebRequiredMessage" v-model="vModel.BranchId"
																		:data-text-field="'Text'" :data-value-field="'Id'" :option-label="'Please Select Branch'"
																		:auto-bind="true" :index="0" :data-value-primitive="true" ref="branchdropdownlist"
																		:filter="'startswith'"></kendo-dropdownlist>
													<div v-show="errors.has('Branch')" class="help is-danger">{{ errors.first('Branch') }}</div>
												</div>
											</div>

											<div class="col-sm-4" v-if="vModel.CountryId == 251 && vModel.PayoutModeId == 1 && FieldValidation!=null && FieldValidation.AccountTypeId != null">
												<div class="form-group">
													<label>
														Account Type
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="AccountTypeCollection != null"
																		name='AccountType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('AccountType') }"
																		ref="accounttypedropdownlist" v-model="vModel.AccountTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Account Type'" :auto-bind="true"
																		:data-source="AccountTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'"
																		:data-vv-as='FieldValidation.AccountTypeId.WebRequiredMessage'
																		@change="onChangeAccountType">
													</kendo-dropdownlist>
													<div v-show="errors.has('ReceiverType')" class="help is-danger">
														{{ errors.first('AccountType') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="vModel.CountryId == 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && !accountNoValidation.IsAccValidationActive">
												<div class="form-group">

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off" v-mask="accountMask"
														   v-model="vModel.AccountNumber"
														   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
														   v-only-text-number='' maxlength="30"
														   v-validate="'required|BankAccount:'+vModel.CountryId"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger" v-html="errors.first('AccountNumber')">
													</div>

												</div>
											</div>

											<div class="col-lg-8"
												 v-if="vModel.CountryId == 251 && FieldValidation != null && FieldValidation.AccountNumber != null && FieldValidation.AccountNumber.Note">
												<div class="col-lg-12">
													<label>
														<font color='red'>
															Note: <br />
															{{FieldValidation.AccountNumber.Note}}
														</font>
													</label>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 48 && vModel.PayoutModeId == 25">
												<div class="form-group">

													<div>
														<label>
															Wing Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="10" minlength="8"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 48 && vModel.PayoutModeId == 25">
												<button class="btn red-btn" @click="verifyWingWalletNumber()" :disabled="IsWingWalletVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<div class="row">
												<div class="col-lg-12" v-if="IsWingWalletValidationChecked">
													<label>
														<strong>Result</strong><br>
														<strong>Account Name : {{this.WingWalletFullName}}</strong><br>
														<strong>Currency : {{this.WingWalletCurrency}}</strong><br />
														<strong v-if="this.IsValidWingWalletNumber">Validation : Success</strong>
														<strong v-else-if="!this.IsValidWingWalletNumber">Validation : Failed</strong>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div>
								<div class="form-card" v-if="vModel.PayoutModeId == 2 || vModel.PayoutModeId == 34 || vModel.PayoutModeId == 35">
									<div class="form-card-header">
										<h3>Agent Details</h3>
									</div>
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for>
														Agent
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="AgentCollection != null" name="AgentId" v-validate="'required'"
																		class="form-control" :class="{'input': true, 'is-danger': errors.has('AgentId') }"
																		ref="agentdropdownlist" v-model="vModel.AgentId" :data-text-field="'Text'"
																		:data-value-field="'Id'" :option-label="'Please Select Agent'" :auto-bind="true"
																		:data-source="AgentCollection" :data-value-primitive="true" data-vv-as="Receivers agent"
																		@change="onChangeAgentDropDown" @dataBound="onAgentDropDownBound"></kendo-dropdownlist>
													<div v-show="errors.has('AgentId')" class="help is-danger">{{ errors.first('AgentId') }}</div>
												</div>
											</div>
											<div class="col-lg-6">
												<div class="form-group">
													<label for>Remarks</label>
													<div class="input-group mb-3">
														<p class="notice">{{Remarks}}</p>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-12">
												<div class="form-group">
													<p class="notice">{{Note}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form-card">
									<div class="form-card-header">
										<h3>Recipient Details</h3>
									</div>
									<div class="form-card-forms">
										<div v-if="vModel.PayoutModeId == 2 ||vModel.PayoutModeId == 34 ||vModel.PayoutModeId == 35">
											<div class="row">
												<div class="col-sm-4" v-if="FieldValidation!=null && FieldValidation.ReceiverTypeId != null">
													<div class="form-group">
														<label>
															Receiver Type
															<span class="required">*</span>
														</label>
														<kendo-dropdownlist v-if="ReceiverTypeCollection != null"
																			name='ReceiverType' v-validate="'required'"
																			class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('ReceiverType') }"
																			ref="receivertypedropdownlist" v-model="vModel.ReceiverTypeId"
																			:data-text-field="'Text'" :data-value-field="'Id'"
																			:option-label="'Please Select Receiver Type'" :auto-bind="true"
																			:data-source="ReceiverTypeCollection"
																			:data-value-primitive="true" :filter="'startswith'"
																			:data-vv-as='FieldValidation.ReceiverTypeId.WebRequiredMessage'
																			@change="onChangeReceiverType">
														</kendo-dropdownlist>
														<div v-show="errors.has('ReceiverType')" class="help is-danger">
															{{ errors.first('ReceiverType') }}
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-lg-8"
												 v-if="vModel.ReceiverTypeId == 2 && FieldValidation != null && FieldValidation.CompanyName != null">
												<div class="form-group">
													<label for="">
														Company Name
														<span v-if="FieldValidation.CompanyName.Required == true"
															  class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														   name="CompanyName" autocomplete="off" v-model="vModel.CompanyName"
														   :data-vv-as='FieldValidation.CompanyName.WebRequiredMessage'
														   :class="{'input': true, 'is-danger': errors.has('CompanyName') }"
														   v-validate="'required'"
														   v-only-uppercase />
													<div v-show="errors.has('CompanyName')" class="help is-danger">
														{{ errors.first('CompanyName') }}
													</div>

												</div>
											</div>

											<div class="col-lg-4" v-if="vModel.ReceiverTypeId != 2 && FieldValidation != null && FieldValidation.FirstName != null">
												<div class="form-group">
													<label for>
														First Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="FirstName" autocomplete="off" @input="DeActivateSaveButton"
														   v-model="vModel.FirstName" :data-vv-as="FieldValidation.FirstName.WebRequiredMessage"
														   v-validate="this.GroupCode=='KH03' ? {required: true, regex: '^[A-Za-z ]+$'} : {required: true}"
														   :class="{'input': true, 'is-danger': errors.has('FirstName') }"
														   v-only-uppercase />
													<div v-show="errors.has('FirstName')" class="help is-danger">
														{{ errors.first('FirstName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="vModel.ReceiverTypeId != 2 && FieldValidation != null && FieldValidation.LastName != null">
												<div class="form-group">
													<label for>
														Last Name
														<span v-if="FieldValidation.LastName.Required == true" class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="LastName" autocomplete="off" @input="DeActivateSaveButton"
														   v-model="vModel.LastName" :data-vv-as="FieldValidation.LastName.WebRequiredMessage"
														   v-validate="FieldValidation.LastName.Required == true ? (this.GroupCode=='KH03' ? {required: true, regex: '^[A-Za-z ]+$'} : {required: true}) : (this.GroupCode=='KH03' ? {regex: '^[A-Za-z ]+$'} : '')"
														   :class="{'input': true, 'is-danger': errors.has('LastName') }" v-only-uppercase />
													<div v-show="errors.has('LastName')" class="help is-danger">
														{{ errors.first('LastName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.RelationshipId != null" :key="relationshipDropdownKey">
												<div class="form-group">
													<label for>
														Relationship
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<kendo-dropdownlist v-if="RelationshipCollection != null" name="RelationShipId"
																			@change="onChangeRelationship" @databound="onRelationshipBound" v-validate="'required'" class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('RelationShipId') }"
																			ref="relationshipdropdownlist" v-model="vModel.RelationshipId" :data-text-field="'Text'"
																			:data-value-field="'Id'" :option-label="'Please Select Relationship'" :auto-bind="true"
																			:data-source=" vModel.CountryId != 123 && vModel.CountryId != 48  && vModel.CountryId != 114? RelationshipCollection : IndiaRelationshipCollection" :data-value-primitive="true"
																			:data-vv-as="FieldValidation.RelationshipId.WebRequiredMessage"></kendo-dropdownlist>
														<div v-show="errors.has('RelationShipId')" class="help is-danger">
															{{ errors.first('RelationShipId') }}
														</div>
														<div v-show="showAdditionalRelationshipMessage"
															 class="help is-danger">
															{{ additionalRelationshipMessage }}
														</div>
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.MobileContact != null">

												<div class="form-group">
													<label>
														Mobile Number
														<span class="required">*</span>
													</label>

													<!-- Japan -->
													<div class="input-group" v-if="vModel.CountryId == 123">
														<div class="input-group-prepend">
															<span class="input-group-text">+81</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal maxlength="10"
															   v-model="vModel.MobileContact"
															   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
															   v-validate="'required|max:18|mobile_japan'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>

													<!-- Australia -->
													<div class="input-group" v-else-if="vModel.CountryId == 23">
														<div class="input-group-prepend">
															<span class="input-group-text">+61</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal maxlength="12"
															   v-model="vModel.MobileContact"
															   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
															   v-validate="'required|max:18|mobile'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>

													<!-- Hong Kong -->
													<div class="input-group" v-else-if="vModel.CountryId == 114">
														<div class="input-group-prepend">
															<span class="input-group-text">+852</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal maxlength="26"
															   v-model="vModel.MobileContact"
															   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
															   v-validate="'required|max:26|mobile_hongkong'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>

													<!-- USA -->
													<div class="input-group" v-else-if="vModel.CountryId == 251">
														<div class="input-group-prepend">
															<span class="input-group-text">+1</span>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal maxlength="12"
															   v-model="vModel.MobileContact"
															   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
															   v-validate="'required|max:18|mobile'"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>

													<!-- Cambodia (with Telco Prefix) -->
													<div class="input-group" v-else-if="vModel.CountryId == 48">
														<div style="width: 100px;">
															<select class="form-control" name="TelcoMobileCodePrefix"
																	v-model="vModel.TelcoMobileCodePrefix" v-validate="'required'">
																<option value="">Select</option>
																<option v-for="prefixItem in CambodiaMobilePrefixCollection"
																		:key="prefixItem" :value="prefixItem">
																	{{ prefixItem }}
																</option>
															</select>
														</div>
														<input type="text" class="form-control" name="MobileContact"
															   autocomplete="off" v-mobile-normal maxlength="9" minlength="6"
															   v-model="vModel.MobileContact"
															   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
															   v-validate="'required|min:'+FieldValidation.MobileContact.MinLength+'|max:'+FieldValidation.MobileContact.MaxLength"
															   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													</div>

													<!-- Default / Other Countries (No prefix) -->
													<input v-else type="text" class="form-control" name="MobileContact"
														   autocomplete="off" v-mobile-normal maxlength="18"
														   v-model="vModel.MobileContact"
														   :data-vv-as="FieldValidation.MobileContact.WebRequiredMessage"
														   v-validate="'required|max:18|mobile'"
														   :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />

													<div v-show="errors.has('MobileContact')" class="help is-danger">
														{{ errors.first('MobileContact') }}
													</div>
													<div v-show="errors.has('DialCode') || errors.has('TelcoMobileCodePrefix')" class="help is-danger">
														{{ errors.first('DialCode') || errors.first('TelcoMobileCodePrefix') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="(FieldValidation != null && FieldValidation.Email != null && vModel.CountryId == 23 && vModel.PayoutModeId == 1)">
												<div class="form-group">
													<label for>
														Email
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control" name="Email" autocomplete="off" v-model="vModel.Email"
														   :data-vv-as="FieldValidation.Email.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.Email.MinLength+'|max:'+FieldValidation.Email.MaxLength+'|email_aus'"
														   :class="{'input': true, 'is-danger': errors.has('Email') }" />
													<div v-show="errors.has('Email')" class="help is-danger">{{ errors.first('Email') }}</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.NationalityId != null">
												<div class="form-group">
													<label for>
														Nationality
														<span class="required">*</span>
													</label>

													<kendo-dropdownlist v-if="NationalityCollection != null" name="NationalityId"
																		v-validate="'required'" class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('NationalityId') }"
																		ref="nationalitydropdownlist" v-model="vModel.NationalityId" :data-text-field="'Text'"
																		:data-value-field="'Id'" :option-label="'Please Select Nationality'" :auto-bind="true"
																		:data-source="NationalityCollection" :data-value-primitive="true"
																		:data-vv-as="FieldValidation.NationalityId.WebRequiredMessage"
																		:disabled="FieldValidation.NationalityId.IsReadOnlyField"></kendo-dropdownlist>
													<div v-show="errors.has('NationalityId')" class="help is-danger">
														{{ errors.first('NationalityId') }}
													</div>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.HouseNo != null && FieldValidation.HouseNo.MaxLength == null && FieldValidation.HouseNo.MinLength == null">
												<div class="form-group">
													<label for>
														House No./ Unit No.
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="HouseNo" autocomplete="off"
														   v-model="vModel.HouseNo" :data-vv-as="FieldValidation.HouseNo.WebRequiredMessage"
														   v-validate="'required|max:75'" :class="{'input': true, 'is-danger': errors.has('HouseNo') }"
														   v-only-uppercase />
													<div v-show="errors.has('HouseNo')" class="help is-danger">{{ errors.first('HouseNo') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.HouseNo != null && FieldValidation.HouseNo.MaxLength != null && FieldValidation.HouseNo.MinLength != null">
												<div class="form-group">
													<label for>
														House No./ Unit No.
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="HouseNo" autocomplete="off"
														   v-model="vModel.HouseNo" :data-vv-as="FieldValidation.HouseNo.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.HouseNo.MinLength+'|max:'+FieldValidation.HouseNo.MaxLength+'|House_No:'+FieldValidation.HouseNo.Regex.replace(',', '%')+','+FieldValidation.HouseNo.RegexMessage"
														   :class="{'input': true, 'is-danger': errors.has('HouseNo') }" v-only-uppercase />
													<div v-show="errors.has('HouseNo')" class="help is-danger">{{ errors.first('HouseNo') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Address != null && FieldValidation.Address.MinLength != null && FieldValidation.Address.MaxLength != null  && ( vModel.ReceiverTypeId == 2 ||vModel.CountryId == 250)">
												<div class="form-group">
													<label for>
														Address
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Address" autocomplete="off"
														   v-model="vModel.Address" :data-vv-as="FieldValidation.Address.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.Address.MinLength+'|max:'+FieldValidation.Address.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('Address') }" v-only-uppercase />
													<div v-show="errors.has('Address')" class="help is-danger">{{ errors.first('Address') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.StreetNo != null && FieldValidation.StreetNo.MinLength != null && FieldValidation.StreetNo.MaxLength != null">
												<div class="form-group">
													<label for>
														Street Number
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" v-only-numeric name="StreetNo"
														   autocomplete="off" v-model="vModel.StreetNo"
														   :data-vv-as="FieldValidation.StreetNo.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.StreetNo.MinLength+'|max:'+FieldValidation.StreetNo.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('StreetNo') }" v-only-uppercase />
													<div v-show="errors.has('StreetNo')" class="help is-danger">
														{{ errors.first('StreetNo') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MaxLength == null && FieldValidation.Street.MinLength == null">
												<div class="form-group">
													<label for>
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street" autocomplete="off"
														   v-model="vModel.Street" :data-vv-as="FieldValidation.Street.WebRequiredMessage"
														   v-validate="'required|max:75'" :class="{'input': true, 'is-danger': errors.has('Street') }"
														   v-only-uppercase />
													<div v-show="errors.has('Street')" class="help is-danger">{{ errors.first('Street') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MaxLength != null && FieldValidation.Street.MinLength != null && vModel.CountryId != 250">
												<div class="form-group">
													<label for>
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street" autocomplete="off"
														   v-model="vModel.Street" :data-vv-as="FieldValidation.Street.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.Street.MinLength+'|max:'+FieldValidation.Street.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('Street') }" v-only-uppercase />
													<div v-show="errors.has('Street')" class="help is-danger">{{ errors.first('Street') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.Street != null && FieldValidation.Street.MinLength != null && FieldValidation.Street.MaxLength != null && vModel.CountryId == 250">
												<div class="form-group">
													<label for>
														Street Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street" v-only-text-number
														   autocomplete="off" v-model="vModel.Street"
														   :data-vv-as="FieldValidation.Street.WebRequiredMessage"
														   v-validate="'required|min:'+FieldValidation.Street.MinLength+'|max:'+FieldValidation.Street.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('Street') }" v-only-uppercase />
													<div v-show="errors.has('Street')" class="help is-danger">{{ errors.first('Street') }}</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.StreetTypeId != null">
												<div class="form-group">
													<label for>
														Street Type
														<span class="required">*</span>
													</label>
													<div class="input-group mb-3">
														<kendo-dropdownlist v-if="StreetTypeCollection != null" name="StreetTypeId"
																			v-validate="'required'" class="form-control"
																			:class="{'input': true, 'is-danger': errors.has('StreetTypeId') }"
																			ref="streettypedropdownlist" v-model="vModel.StreetTypeId" :data-text-field="'Text'"
																			:data-value-field="'Id'" :option-label="'Please Select Street Type'" :auto-bind="true"
																			:data-source="StreetTypeCollection" :data-value-primitive="true"
																			:data-vv-as="FieldValidation.StreetTypeId.WebRequiredMessage"></kendo-dropdownlist>
														<div v-show="errors.has('StreetTypeId')" class="help is-danger">
															{{ errors.first('StreetTypeId') }}
														</div>
													</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.PostCode != null">
												<div class="form-group" v-if="vModel.CountryId == 23">
													<label for>
														Post Code
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="PostCode" autocomplete="off" v-only-numeric
														   v-model="vModel.PostCode" :data-vv-as="FieldValidation.PostCode.WebRequiredMessage"
														   v-validate="vModel.CountryId == 251 ? 'required' : vModel.CountryId == 123 ? 'required|JapanPostCode' : vModel.CountryId == 23 ? 'required|AusPostCode' : 'required:max:50'"
														   :class="{'input': true, 'is-danger': errors.has('PostCode') }" />
													<div v-show="errors.has('PostCode')" class="help is-danger">
														{{ errors.first('PostCode') }}
													</div>
												</div>
												<div class="form-group" v-else>
													<label for>
														Post Code
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="PostCode" autocomplete="off"
														   v-model="vModel.PostCode" :data-vv-as="FieldValidation.PostCode.WebRequiredMessage"
														   v-validate="vModel.CountryId == 251 ? 'required' : vModel.CountryId == 123 ? 'required|JapanPostCode' : vModel.CountryId == 23 ? 'required|AusPostCode' : 'required:max:50'"
														   :class="{'input': true, 'is-danger': errors.has('PostCode') }" />
													<div v-show="errors.has('PostCode')" class="help is-danger">
														{{ errors.first('PostCode') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.City != null">
												<div class="form-group">
													<label for>
														City
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="City" autocomplete="off"
														   v-model="vModel.City" :data-vv-as="FieldValidation.City.WebRequiredMessage"
														   v-validate="'required|min:3|max:50'" :class="{'input': true, 'is-danger': errors.has('City') }"
														   v-only-uppercase />
													<div v-show="errors.has('City')" class="help is-danger">{{ errors.first('City') }}</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.StateId != null">
												<div class="form-group">
													<label>
														State
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="StateCollection != null" name="StateId" v-validate="'required'"
																		class="form-control" :class="{'input': true, 'is-danger': errors.has('StateId') }"
																		ref="statedropdownlist" v-model="vModel.StateId" :data-text-field="'Text'"
																		:data-value-field="'Id'" :option-label="'Please Select State'" :auto-bind="true"
																		:data-source="StateCollection" :data-value-primitive="true"
																		:data-vv-as="FieldValidation.StateId.WebRequiredMessage" @change="onChangeState"
																		@dataBound="onStateDropDownBound"></kendo-dropdownlist>
													<div v-show="errors.has('StateId')" class="help is-danger">{{ errors.first('StateId') }}</div>
												</div>
											</div>
											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.StateName != null">
												<div class="form-group">
													<label for>
														State
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="StateName" autocomplete="off"
														   v-model="vModel.StateName" :data-vv-as="FieldValidation.StateName.WebRequiredMessage"
														   v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('StateName') }"
														   v-only-uppercase />
													<div v-show="errors.has('StateName')" class="help is-danger">
														{{ errors.first('StateName') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4" v-if="FieldValidation != null && FieldValidation.CityId != null">
												<div class="form-group">
													<label>
														City
														<span class="required">*</span>
													</label>
													<kendo-dropdownlist name="CityId" v-validate="'required'" class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('CityId') }" ref="citydropdownlist"
																		v-model="vModel.CityId" :data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select City'" :auto-bind="true" :data-value-primitive="true"
																		:data-vv-as="FieldValidation.CityId.WebRequiredMessage"></kendo-dropdownlist>
													<div v-show="errors.has('CityId')" class="help is-danger">{{ errors.first('CityId') }}</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 1 && (vModel.PayoutModeId == 23 ||vModel.PayoutModeId == 30)">
												<div class="form-group">

													<div>
														<label>
															{{vModel.PayoutModeId ==23 ? "bKash Wallet Number" :"eWallet Number"}}
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group" v-if="vModel.PayoutModeId == 23">
														<div class="input-group-prepend"><span class="input-group-text" style="color:#000;"><span>+88 </span></span></div>

														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="11"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div class="input-group" v-if="vModel.PayoutModeId == 30">
														<div class="input-group-prepend">
															<span class="input-group-text" style="color:#000;">
																<span>+88 </span>
															</span>
														</div>

														<input type="text"
															   class="form-control text-uppercase"
															   name="AccountNumber"
															   autocomplete="off"
															   v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric
															   maxlength="11"
															   v-validate="'required|min:11|max:11'"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>

													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 1 && vModel.PayoutModeId == 23 && this.IsAccountValidationRequired">
												<button class="btn red-btn" @click="verifybKash()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 7 && vModel.PayoutModeId == 26">
												<div class="form-group">

													<div>
														<label>
															MCB Wallet Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off" v-mask="accountMask"
														   v-model="vModel.AccountNumber"
														   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
														   v-only-numeric='' maxlength="11"
														   v-validate="'required|BankAccount:'+vModel.CountryId"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>

													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 7 && vModel.PayoutModeId == 26">
												<button class="btn red-btn" @click="verifyMCB()" :disabled="IsMCBVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 10 && (vModel.PayoutModeId == 32 || vModel.PayoutModeId == 33)">
												<div class="form-group">

													<div>
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="11"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 10 && (vModel.PayoutModeId == 32 || vModel.PayoutModeId == 33) && IsAccountValidationRequired">
												<button class="btn red-btn" @click="ValidateCommonwalletnumber()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 5 && vModel.PayoutModeId == 31">
												<div class="form-group">

													<div>
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>
													<div class="input-group">
														<input type="text" class="form-control text-uppercase"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-numeric='' maxlength="11"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>

													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>

											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 5 && vModel.PayoutModeId == 31 && IsAccountValidationRequired">
												<button class="btn red-btn" @click="ValidateCommonwalletnumber()" :disabled="IsBkashVerify" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>

										</div>
										<!-- In case Of Indonessia -->
										<div class="row" v-if="vModel.PayoutModeId == 2 && vModel.CountryId == 3">
											<div class="col-lg-12">
												<label>
													<font color="red">
														Note:
														<br />Receivers Address must be the same as the address that appears
														in your receivers Indonesian
														National Id (Kartu Tanda Penduduk - KTP)
													</font>
												</label>
											</div>
										</div>
										<!-- Indonessia End -->
										<div class="row"
											 v-if="vModel.PayoutModeId == 1 || vModel.PayoutModeId == 21 || vModel.PayoutModeId == 22 || vModel.PayoutModeId == 29">
											<div class="col-lg-4"
												 v-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && !accountNoValidation.IsAccValidationActive">
												<div class="form-group">

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>
													<div v-if="vModel.CountryId == 131">
														<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-validate="'required|account_format'"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>
													<div v-else>
														<input type="text" class="form-control text-uppercase" @input="DeActivateSaveButton"
															   name="AccountNumber" autocomplete="off" v-mask="accountMask"
															   v-model="vModel.AccountNumber"
															   :data-vv-as='FieldValidation.AccountNumber.WebRequiredMessage'
															   v-only-text-number='' maxlength="30"
															   v-validate="'required|BankAccount:'+vModel.CountryId"
															   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
															   v-only-uppercase>
													</div>
													<div v-show="errors.has('AccountNumber')" class="help is-danger" v-html="errors.first('AccountNumber')">
													</div>

												</div>
											</div>
											<div class="col-lg-4"
												 v-else-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 1 && accountNoValidation.IsAccValidationActive">
												<div class="form-group" v-if='accountNoValidation.Type == "ALPHANUMERIC"'>

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off"
														   data-vv-as="Account Number"
														   v-model="vModel.AccountNumber"
														   v-only-text-number
														   :maxlength="accountNoValidation.MaxLength"
														   v-validate="'required|BankAccount_Validation:'+vModel.CountryId+','+accountNoValidation.RequiredMessage + ','+accountNoValidation.Type + ','+accountNoValidation.MinLength + ','+accountNoValidation.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>
												<div class="form-group" v-else>

													<div>
														<label>
															Account Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="AccountNumber" autocomplete="off"
														   data-vv-as="Account Number"
														   v-model="vModel.AccountNumber"
														   v-only-numeric
														   :maxlength="accountNoValidation.MaxLength"
														   v-validate="'required|BankAccount_Validation:'+vModel.CountryId+','+accountNoValidation.RequiredMessage + ','+accountNoValidation.Type + ','+accountNoValidation.MinLength + ','+accountNoValidation.MaxLength"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>

												</div>
											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 3 && vModel.PayoutModeId == 1 && this.IsAccountValidationRequired">
												<button class="btn red-btn" @click="verifyIndonesiaBankAccount()" :disabled="IsIndonesiaVerify"
														type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<div class="col-lg-4" v-if="vModel.CountryId == 56 && vModel.PayoutModeId == 22">
												<div class="form-group">
													<div>
														<label>
															Receiver Name
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase" :disabled="true" name="WalletName"
														   autocomplete="off" v-model="walletName" :class="{'input': true}" />
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 22">
												<div class="form-group">
													<div v-if="vModel.CountryId == 56 && vModel.PayoutModeId == 22">
														<label>
															Wallet Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control" name="AccountNumber" autocomplete="off"
														   v-model="vModel.AccountNumber"
														   :data-vv-as="FieldValidation.AccountNumber.WebRequiredMessage" maxlength="64"
														   v-validate="'required'"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }" />
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.PayoutModeId == 21">
												<div class="form-group">
													<div>
														<label>
															UnionPay Card Number
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase" name="AccountNumber" autocomplete="off"
														   v-model="vModel.AccountNumber"
														   :data-vv-as="FieldValidation.AccountNumber.WebRequiredMessage" v-only-text-number
														   maxlength="30" v-validate="'required|BankAccount:'+vModel.CountryId"
														   :class="{'input': true, 'is-danger': errors.has('AccountNumber') }" v-only-uppercase />
													<div v-show="errors.has('AccountNumber')" class="help is-danger"
														 v-html="errors.first('AccountNumber')"></div>
												</div>
											</div>
											<div class="col-lg-2" style="margin-top: 36px;"
												 v-if="FieldValidation != null && FieldValidation.AccountNumber != null && vModel.CountryId == 56 && vModel.PayoutModeId == 21  && vModel.PayoutGroupName == 'UNIONPAY TERRAPAY'">
												<button class="btn red-btn" @click="verifyUnionpay()" type="button">
													<span class="btn-content">Verify</span>
												</button>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ABNNumber != null && vModel.PayoutModeId == 1 && vModel.CountryId == 23 && vModel.ReceiverTypeId == 2">
												<div class="form-group">

													<div>
														<label>
															ABN No
															<span class="required">*</span>
														</label>
													</div>

													<input type="text" class="form-control text-uppercase"
														   name="ABNNumber" autocomplete="off"
														   maxlength="50"
														   v-validate="'required|max:'+FieldValidation.ABNNumber.MaxLength"
														   :data-vv-as='FieldValidation.ABNNumber.WebRequiredMessage'
														   v-model="vModel.ABNNumber"
														   v-only-text-number
														   :class="{'input': true, 'is-danger': errors.has('ABNNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('ABNNumber')" class="help is-danger">
														{{ errors.first('ABNNumber') }}
													</div>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.CompanyTypeId != null && vModel.PayoutModeId == 1 && (vModel.CountryId == 23 || vModel.CountryId == 251 || vModel.CountryId == 2) && vModel.ReceiverTypeId == 2">
												<div class="form-group">

													<div>
														<label>
															Company Type
															<span class="required">*</span>
														</label>
													</div>
													<kendo-dropdownlist v-if="CompanyTypeCollection != null"
																		name='CompanyType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('CompanyType') }"
																		ref="companytypedropdownlist" v-model="vModel.CompanyTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Company Type'" :auto-bind="true"
																		:data-source="CompanyTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'"
																		@change="onChangeCompanyTypeDropDown"
																		:data-vv-as='FieldValidation.CompanyTypeId.WebRequiredMessage'
																		@dataBound="onCompanyTypeDropDownBound">
													</kendo-dropdownlist>
													<div v-show="errors.has('CompanyType')" class="help is-danger">
														{{ errors.first('CompanyType') }}
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverIdTypeId != null && ((vModel.PayoutModeId == 21 && vModel.CountryId == 56 && vModel.PayoutGroupName == 'UNIONPAY THUNES') || ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10))">
												<div class="form-group">

													<div>
														<label>
															Receiver ID Type
															<span class="required">*</span>
														</label>
													</div>
													<kendo-dropdownlist v-if="ReceiverIdTypeCollection != null"
																		name='IdType' v-validate="'required'"
																		class="form-control"
																		:class="{'input': true, 'is-danger': errors.has('ReceiverIdType') }"
																		ref="idtypedropdownlist" v-model="vModel.ReceiverIdTypeId"
																		:data-text-field="'Text'" :data-value-field="'Id'"
																		:option-label="'Please Select Id Type'" :auto-bind="true"
																		:data-source="ReceiverIdTypeCollection"
																		:data-value-primitive="true" :filter="'startswith'">
													</kendo-dropdownlist>

												</div>
											</div>
											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverIdNumber != null && ((vModel.PayoutModeId == 21 && vModel.CountryId == 56 && vModel.PayoutGroupName == 'UNIONPAY THUNES') || ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10))">
												<div class="form-group">

													<div>
														<label>
															Receiver ID Number
															<span class="required">*</span>
														</label>
													</div>
													<input type="text" class="form-control text-uppercase"
														   name="ReceiverIdNumber" autocomplete="off" v-mask="accountMask"
														   v-model="vModel.ReceiverIdNumber"
														   v-only-text-number='' maxlength="30"
														   v-validate="'required'"
														   :class="{'input': true, 'is-danger': errors.has('ReceiverIdNumber') }"
														   v-only-uppercase>
													<div v-show="errors.has('ReceiverIdNumber')" class="help is-danger" v-html="errors.first('ReceiverIdNumber')">
													</div>
												</div>
											</div>

											<div class="col-lg-4"
												 v-if="FieldValidation != null && FieldValidation.ReceiverDateOfBirth != null && ((vModel.PayoutModeId == 1 || vModel.PayoutModeId == 29) && vModel.CountryId == 10)">
												<div class="form-group">
													<div>
														<label>
															Date Of Birth
															<span class="required">*</span>
														</label>
													</div>
													<kendo-datepicker class="form-control" :format="'dd/MM/yyyy'"
																	  id="dobirth"
																	  name="dobirth"
																	  v-model="vModel.ReceiverDateOfBirth"
																	  data-vv-as='Date Of Birth'
																	  v-validate="'required'"
																	  onkeydown="return false;"
																	  :class="{'input': true, 'is-danger': errors.has('dobirth') }"
																	  ref="ReceiverDateOfBirth">
													</kendo-datepicker>
												</div>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 21 && vModel.CountryId == 56">
											<div class="col-lg-12">
												<label>
													<font color="red">
														Note:
														<br />Only China Union Pay Debit Card number starting with 6, 62,
														955880, 955882 or 955888 are supported.
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 22 && vModel.CountryId == 56" style="display: none;">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">1. Receivers Alipay Wallet must be registered in China.</font></pre>
													<pre class="note"><font color="red">2. Receivers name must match the name registered with Alipay Wallet.</font></pre>
													<pre class="note"><font color="red">3. Funds will be credited to the receiver’s bank account linked to the Wallet.</font></pre>

												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 1 && vModel.CountryId == 3 && this.IsAccountValidationRequired">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">Receiver's Name must be exactly the same as the displayed name above.</font></pre>

												</label>
											</div>
										</div>
										<div class="row"
											 v-if="vModel.CountryId != 251 && FieldValidation != null && FieldValidation.AccountNumber != null && FieldValidation.AccountNumber.Note">
											<div class="col-lg-12">
												<label>
													<font color="red">
														Note: <br />
														{{FieldValidation.AccountNumber.Note}}
													</font>
												</label>
											</div>
										</div>
										<!-- In Case of Japan -->
										<div class="row"
											 v-if="FieldValidation != null && FieldValidation.NationalityId != null && FieldValidation.NationalityId.Note">
											<div class="col-lg-12">
												<label>
													<font color="red">
														Note:
														<br />
														{{FieldValidation.NationalityId.Note}}
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.CountryId == 250">
											<div class="col-lg-12">
												<label for="">
													<font color="red">
														Note: <br />
														United Kingdom Account Number format should be Sort Code (6 Digits) + Account No (8-10 Digits) i.e xxxxxx-xxxxxxxxxx <a target="_blank" href="https://www.sortcodes.co.uk/">UK SortCode Link</a>
													</font>
												</label>
											</div>
										</div>

										<div class="row" v-show="IsValidBkashNumber">
											<div class="col-lg-12">
												<label>
													<strong>Result</strong><br>
													<strong>Receiver's Name : {{BkashReceiverName}}</strong>
												</label>
											</div>
										</div>
										<div class="row" v-show="IsUnionpayVerify">
											<div class="col-lg-12">
												<label>
													<strong>Result</strong><br>
													<strong>Validation : {{IsValidUnionpayCardNumber ? "Success" : "Failed"}}</strong>
												</label>
											</div>
										</div>
										<div class="row" v-if="showB2BMessage">
											<div class="col-lg-12">
												<label for="">
													<font color="red">
														Note: <br />
														Sending money to corporates is not permitted. Please sign up at <a target="_blank" href="https://www.bizpayments.com.my/">https://www.bizpayments.com.my/</a> for corporate transactions.
													</font>
												</label>
											</div>
										</div>
										<div class="row" v-if="vModel.PayoutModeId == 1 && vModel.CountryId == 131">
											<div class="col-lg-12">
												<label>
													<pre class="note"><font color="red">Note: </font></pre>
													<pre class="note"><font color="red">South Korea's bank account number format should be Bank Code (3 Digits) + Branch Code (3 to 4 Digits) + Account No (6 to 9 Digits)</font></pre>
													<pre class="note"><font color="red">i.e. xxx-xxxx-xxxxxxx</font></pre>

												</label>
											</div>
										</div>
									</div>
									<!-- eo form card forms -->
								</div>
							</div>
						</div>
						<div v-if="vModel.TransactionRefNo != null">
							<div class="form-card">
								<div class="form-card-header">
									<h3>Beneficial Owner</h3>
								</div>
								<div class="form-card">
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<label for="">
													Are you helping someone send money?
												</label>
											</div>
											<div class="col-lg-2">
												<label class="toggle-switchy" for="isOnBehalfTransaction" data-size="xs" data-style="rounded">
													<input type="checkbox"
														   id="isOnBehalfTransaction"
														   v-model="onbehalfRelatedModel.isOnBehalfTransaction"
														   name="isOnBehalfTransaction">
													<span class="toggle">
														<span class="switch"></span>
													</span>
												</label>
											</div>
										</div>
										<div class="row" v-if="onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId">
											<div class="col-lg-6">
												<div class="onbehalf-name-wrapper">
													<div class="onbehalf-txn-name">
														{{onbehalfRelatedModel.OnBehalfDetail.Name}}
													</div>
													<div class="close-btn" @click="onRemoveOnBehalfCustomer">
														<i class="material-icons">close</i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form-card" v-if="onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId">
								<div class="form-card-header">
									<h3>Beneficial Owner Details</h3>
								</div>
								<div class="form-card-forms">
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Full Name
												</label>
												<input type="text" class="form-control" readonly="true" name="Name" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.Name" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Nationality
												</label>
												<input type="text" class="form-control" readonly="true" name="Nationality" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.NationalityText" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Id Type
												</label>
												<input type="text" class="form-control" readonly="true" name="IdType" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.IdTypeText" :class="{'input': true}" />
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Id Number
												</label>
												<input type="text" class="form-control" readonly="true" name="IdNumber" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.IdNumber" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Date Of Birth
												</label>
												<input type="text" class="form-control" readonly="true" name="DateOfBirth" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.DOBString" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Address
												</label>
												<input type="text" class="form-control" readonly="true" name="Address" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.Address" :class="{'input': true}" />
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Contact No.
												</label>
												<input type="text" class="form-control" readonly="true" name="ContactNo" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.MobileContact" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Occupation
												</label>
												<input type="text" class="form-control" readonly="true" name="Occupation" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.OccupationText" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													Employer Name
												</label>
												<input type="text" class="form-control" readonly="true" name="EmployerName" autocomplete="off"
													   v-model="onbehalfRelatedModel.OnBehalfDetail.EmployerName" :class="{'input': true}" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													ID Images
												</label>
												<div>
													<p class='image-link' v-if="onbehalfRelatedModel.OnBehalfDetail.IdFrontFileName"
													   @click="onViewDocument(onbehalfRelatedModel.OnBehalfDetail.IdFrontImage)">
														{{onbehalfRelatedModel.OnBehalfDetail.IdFrontFileName}}</a>
													</p>
													<p class='image-link' v-if="onbehalfRelatedModel.OnBehalfDetail.IdBackFileName"
													   @click="onViewDocument(onbehalfRelatedModel.OnBehalfDetail.IdBackImage)">
														{{onbehalfRelatedModel.OnBehalfDetail.IdBackFileName}}</a>
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="txnrefno">
							<div class="form-card">
								<div class="form-card-header">
									<h3>Transaction Detail</h3>
								</div>
								<div class="form-card-forms">
									<div class="row">
										<div class="col-md-4">
											<label>Transaction Ref Number</label>
										</div>
										<div class="col-md-8">{{TransactionDetail.TransactionRefNumber}}</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<label>Reason Remark</label>
										</div>
										<div class="col-md-8">{{TransactionDetail.Remark}}</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<label>Send Amount(MYR)</label>
										</div>
										<div class="col-md-8 text-bold">{{TransactionDetail.SendAmount}}</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<label>Payout Amount({{TransactionDetail.PayoutCurrency}})</label>
										</div>
										<div class="col-md-8 text-bold">{{TransactionDetail.PayoutAmount}}</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<label>Exchange Rate</label>
										</div>
										<div class="col-md-8 text-bold">{{TransactionDetail.ExchangeRate}}</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="isOnSecondPage == true || vModel.Id !=null" class="submit-option">
							<div class="left-option">
								<router-link :to="txnrefno ? '/transaction' : '/recipient'" class="btn submit-lefticon-btn">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</router-link>
							</div>
							<div class="right-option">
								<button class="btn submit-righticon-btn" :disabled="(IsBkashBtnDisabled && IsAccountValidationRequired) || IsWingWalletBtnDisabled || IsMCBBtnDisabled || IsUnionpayBtnDisabled || (IsIndonesiaBankAccBtnDisabled && IsAccountValidationRequired)">
									<span class="btn-content">
										{{
mode=="add" ? "Create" : txnrefno != undefined ? "Update and Reprocess" :
                    "Update"
										}}
									</span>
									<span class="right-icon">
										<i class="material-icons">chevron_right</i>
									</span>
								</button>
							</div>
						</div>
					</form>
					<!-- eo main card -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from "vue";
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import ListService from "../../services/list";
	import TransactionService from "../../services/transaction";
	import CommonService from "../../services/common";
	import vSelect from "vue-select";
	Vue.component("v-select", vSelect);
	import { _ } from "vue-underscore";

	import VueMask from "v-mask";
	Vue.use(VueMask);

	import { vueinstance } from "../../main";
	import OnBehalfDetail from "../../shared/OnBehalfDetail.vue";
	import OnBehalfPopup from "../../shared/OnBehalfPopup.vue"
	export default {
		name: "Merchantrade",
		props: ["paymode", "txnrefno"],
		extends: Base,
		components: {
			Action,
			Mode,
			OnBehalfDetail,
			OnBehalfPopup
		},
		created() {
			this.url.add = "recipient/merchantrade/save";
			this.url.edit = "recipient/merchantrade/edit";
			this.url.update = "recipient/merchantrade/save";
			this.url.delete = "recipient/merchantrade/delete";
		},
		mounted() {
			CommonService.removeStorage('BeneOwnerDetail');
			setTimeout(() => {
				if (this.onbehalfRelatedModel.OnBehalfTxnProcessGuardList.length > 0) {
					let priority1 = this.onbehalfRelatedModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 1
					})[0];
					let priority2 = this.onbehalfRelatedModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 2
					})[0];
					let priority3 = this.onbehalfRelatedModel.OnBehalfTxnProcessGuardList.filter(x => {
						return x.Priority == 3
					})[0];

					if (priority1.Value) {
						this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfSwitch = true;
						if (priority2.Value) {
							if (this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId == null) {
								this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
								this.onbehalfRelatedModel.onBehalfDecisionCheck.DisableOnbehalfSwitch = true;
								setTimeout(() => {
									kendo.alert("3rd party relationship selected. Please provide On Behalf details to proceed.");
								}, 100);
							}
						}
						else if (!priority2.Value && priority3.Value) {
							this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfNationalityPopup = true;
						}
					}

				}
				if (this.vModel.PayoutModeId == 23 && this.vModel.CountryId == 1)
					this.IsBkashBtnDisabled = true;
				if (this.vModel.PayoutModeId == 25) {
					this.IsWingWalletBtnDisabled = true;
				}
				if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 21 && this.vModel.PayoutGroupName == 'UNIONPAY TERRAPAY') {
					this.IsUnionpayBtnDisabled = true;
				}
				else if (this.vModel.PayoutModeId == 1 && this.vModel.CountryId == 3) {
					this.IsIndonesiaBankAccBtnDisabled = true;
				}
			}, 1000);
		},
		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(
				ListService.getFeildValidateByBeneficiary(to.params.paymode, to.params.id)
			);
			promises.push(ListService.getNationality());

			if (to.params.paymode != undefined && to.params.id != undefined) {
				promises.push(
					ListService.getById(
						"recipient/merchantrade/get/" + to.params.paymode + "/" + to.params.id
					),
					ListService.get("list/relationship/edit/" + to.params.paymode + "/" + to.params.id),
				);
				promises.push(ListService.getById("recipient/telcomobilecodelist"));
				promises.push(ListService.getById("list/recipientCompanyType"));
				promises.push(ListService.getById("list/idtype"));
				//promises.push(ListService.getById("list/WalletTypes" + this.vModel.CountryId));

				if (to.params.txnrefno != undefined) {
					promises.push(
						ListService.getById("transaction/detail/" + to.params.txnrefno),
						ListService.getOnBehalfList()
					);
				}

				Promise.all(promises).then((response) => {
					next((p) => {
						p.fromPath = from.path;
						p.FieldValidation = response[0].body;
						p.NationalityCollection = response[1].body;
						p.vModel = response[2].body;
						p.accountNumber = response[2].body.AccountNumber;
						//philipines gcash
						if (p.vModel.CountryId == 6 && p.vModel.PayoutModeId == 24 && p.vModel.BankName.toUpperCase() == 'GCASH') {
							p.showGcashAccountPrefix = true;
						}
						//china unionpay
						if (response[2].body.CountryId == 56 && response[2].body.PayoutModeId == 21) {
							p.PayoutGroupCollection = response[2].body.PayoutGroups;
						}

						//Pakistan Invalid Relationships
						if (response[2].body.CountryId == 7 && (response[2].body.RelationshipId == 11 || response[2].body.RelationshipId == 12)) {
							p.vModel.RelationshipId = null;
						}
						p.selectedBranch = {
							Id: p.vModel.BranchId,
							Text: p.vModel.BranchName,
							Address: p.vModel.BranchAddress,
							BranchCode: p.vModel.BranchCode,
						};
						p.RelationshipCollection = response[3].body;
						if (p.vModel.CountryId == 2 || p.vModel.CountryId == 5 || p.vModel.CountryId == 3 || p.vModel.CountryId == 6 || p.vModel.CountryId == 8 || p.vModel.CountryId == 9 || p.vModel.CountryId == 235 || p.vModel.CountryId == 123 || p.vModel.CountryId == 114 || p.vModel.CountryId == 23 || p.vModel.CountryId == 251) {
							p.IndiaRelationshipCollection = response[3].body.filter(item =>
								item.ReceiverTypeId == p.vModel.ReceiverTypeId
							);
						}

						if (!p.RelationshipCollection.some(item => item.Id == p.vModel.RelationshipId)) {
							p.vModel.RelationshipId = null;
						}

						p.CambodiaMobilePrefixCollection = response[4].body;

						p.CompanyTypeCollection = response[5].body;
						//p.ReceiverIdTypeCollection = response[6].body;

						if (p.CambodiaMobilePrefixCollection.indexOf(p.vModel.TelcoMobileCodePrefix) < 0) {
							p.vModel.TelcoMobileCodePrefix = '';
						}

						p.vModel.TransactionRefNo = null;
						p.isOnSecondPage = true;

						p.WalletTypeCollection = response[2].body.EwalletTypes;
						p.ReceiverIdTypeCollection = response[2].body.ReceiverIdTypeList;

						if (to.params.txnrefno != undefined) {
							p.TransactionDetail = response[7].body;
							p.vModel.TransactionRefNo = to.params.txnrefno;
							if (response[7].body.OnBehalfCustomerDetail != undefined && response[7].body.OnBehalfCustomerDetail.OnBehalfCustomerId != null) {
								p.onbehalfRelatedModel.OnBehalfDetail = response[7].body.OnBehalfCustomerDetail;
								p.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfSwitch = true;
								p.onbehalfRelatedModel.isOnBehalfTransaction = true;
								p.onbehalfRelatedModel.isOnBehalfTransactionInit = true;
							}
							p.onbehalfRelatedModel.OnBehalfTxnProcessGuardList = response[7].body.OnBehalfTxnProcessGuardList;
							p.onbehalfRelatedModel.OnBehalfList = response[8].body;
						}
					});
				});
			} else {
				promises.push(ListService.getCountryWithPayout());
				Promise.all(promises).then((response) => {
					next((p) => {
						p.FieldValidation = response[0].body;
						p.NationalityCollection = response[1].body;
						p.CountryCollection = response[2].body;
					});
				});
			}
		},
		data() {
			return {
				accountNumber: null,
				accountNoValidation: {
					RequiredMessage: "",
					Type: "",
					MaxLength: 0,
					MinLength: 0,
					IsAccValidationActive: false
				},
				fromPath: null,
				additionalRelationshipCollection: [7, 8, 15, 16, 17],
				showAdditionalRelationshipMessage: false,
				additionalRelationshipMessage: `3rd party relationship selected. On behalf, details will be required during the transaction.`,
				showB2BMessage: false,
				b2BCountryList: [8, 3, 251, 2, 6, 235, 9, 23,5,114,123],
				optionBranches: [],
				selectedBranch: null,
				ReceiverTypeCollection: [
					{
						Id: 1,
						Text: "Personal",
					},
					{
						Id: 2,
						Text: "Business"
					}],
				AccountTypeCollection: [
					{
						Id: 1,
						Text: "Savings",
					},
					{
						Id: 2,
						Text: "Checking"
					}],
				CompanyTypeCollection: [],
				PayoutGroupCollection: [],
				ReceiverIdTypeCollection: [
					{
						Id: 1,
						Text: "MyKad",
					},
					{
						Id: 4,
						Text: "Passport"
					}
				],
				vModel: {
					Id: null,
					CountryId: null,
					PayoutModeId: null,
					CountryName: null,
					FlagCode: null,
					FirstName: "",
					MiddleName: "",
					LastName: "",
					BankId: null,
					BranchId: null,
					Address: null,
					MobileContact: null,
					AccountNumber: null,
					Street: null,
					City: null,
					StateId: null,
					AgentId: null,
					StateName: null,
					BranchCode: null,
					RelationshipId: null,
					PostCode: null,
					IsNationalIDOld: false,
					NationalId: null,
					AccountInfo: null,
					AccountName: null,
					BankInfo: null,
					TransactionRefNo: null,
					UserId: null,
					PayModeName: null,
					IFSC: null,
					CityId: null,
					StreetTypeId: null,
					StreetNo: null,
					Email: null,
					WingWalletNumber: '',
					TelcoMobileCodePrefix: '',
					CurrencyId: '',
					PayoutGroupName: '',
					ReceiverIdTypeId: '',
					ReceiverIdNumber: '',
					AccountTypeId: null,
					CompanyName: '',
					AccountPrefix: null,
					WalletTypeId: null,
					ReceiverDateOfBirth: null
				},
				toggle: false,
				FlagCode: null,
				isOnSecondPage: false,
				Remarks: null,
				GroupCode: null,
				Note: null,
				CountryCollection: null,
				PayModeCollection: null,
				BankCollection: null,
				WalletTypeCollection: null,
				AccountPrefix: null,
				BranchCollection: null,
				AgentCollection: null,
				RelationshipCollection: null,
				StateCollection: null,
				CitiesCollection: null,
				IfscCode: null,
				TransactionDetail: {
					SendAmount: "",
					PayoutAmount: "",
				},
				FieldValidation: null,
				NationalityCollection: [],
				StreetTypeCollection: null,
				AllBanksList: null,
				onbehalfRelatedModel: {
					//ONBEHALF_RELATED
					OnBehalfTxnProcessGuardList: [],
					onBehalfDecisionCheck: {
						ShowOnbehalfSwitch: false,
						DisableOnbehalfSwitch: false,
						ShowOnbehalfList: false,
						ShowOnbehalfNationalityPopup: false,

					},
					OnBehalfList: [],
					OnBehalfDetail: {
						OnBehalfCustomerId: null,
						Name: null,
						IdNumber: null,
						NationalityText: null,
						IdTypeText: null,
						DOBString: null,
						Address: null,
						EmployerName: null
					},
					isOnBehalfTransaction: false,
					isFromTransaction: false
					//
				},
				IsBkashBtnDisabled: false,
				IsValidBkashNumber: false,
				IsBkashVerify: false,
				IsValidUnionpayCardNumber: false,
				IsUnionpayBtnDisabled: false,
				IsUnionpayVerify: false,
				BKashFirstName: null,
				BkashLastName: null,
				ShowBkashNameMismatchPopup: false,
				CambodiaMobilePrefixCollection: [],
				IsWingWalletBtnDisabled: false,
				IsValidWingWalletNumber: false,
				IsWingWalletValidationChecked: false,
				MCBFirstName: null,
				MCBLastName: null,
				IsMCBBtnDisabled: false,
				IsValidMCBNumber: false,
				IsMCBVerify: false,
				ShowMCBNameMismatchPopup: false,
				IsIndonesiaBankAccBtnDisabled: false,
				IsIndonesiaVerify: false,
				IsValidIndonesiaAccNumber: false,
				ShowIndonesiaAccountMismatchPopup: false,
				IsAccountValidationRequired: true,
				showGcashAccountPrefix: false,
				relationshipDropdownKey: 0,
				ShowReceiverTypePopup: false,
				PendingReceiverFullName: ''
			};
		},

		watch: {
			selectedBranch: function (newValue, oldValue) {
				if (newValue != null) {
					this.vModel.BranchId = newValue.Id;
					this.vModel.BranchCode = newValue.BranchCode;
					this.IfscCode = null;
				} else if (newValue == null && this.IfscCode != null) {
					this.vModel.BranchId = null;
					this.IfscCode = null;
				} else {
					this.vModel.BranchId = null;
					this.vModel.BranchCode = null;
					this.IfscCode = null;
				}
			},
			"vModel.WalletTypeId": function (newvlaue, oldvalue) {
				var selectedVlaue = newvlaue;
				var data = this.WalletTypeCollection.filter(x => x.Id == selectedVlaue);
				if (data.length > 0) {
					var keyValueList = data[0].AccountPrefix;
					if (keyValueList.length > 0) {
						this.IsPrefixAvaliable = true;
						this.$nextTick(function () {
							this.AccountPrefix = keyValueList.map((prefix, index) => { return { Id: index, Text: prefix }; });
							if (this.AccountPrefix != null && oldvalue != null) {
								this.vModel.AccountPrefix = null;
								this.$refs.AccountPrefix.kendoWidget().text('');
							}
						});
					}
					else {
						this.AccountPrefix = null;
						this.vModel.AccountPrefix = null;
						this.IsPrefixAvaliable = false;
					}
				}
				else {
					this.AccountPrefix = null;
					this.vModel.AccountPrefix = null;
					this.IsPrefixAvaliable = false;
				}
			},
			"vModel.CountryId": function (newValue, oldVlaue) {
				if (
					this.mode == "edit" &&
					newValue != null &&
					this.paymode != undefined
				) {
					//     if (this.b2BCountryList.includes(newValue)) {
					//         this.showB2BMessage = true;
					// if (this.vModel.ReceiverTypeId == 1)
					// 	this.showB2BMessage = true;
					// else if (this.vModel.ReceiverTypeId == 2)
					// 	this.showB2BMessage = false;
					//     }

					if (this.paymode == "1" || this.paymode == "23" || this.paymode == "24") {
						var promises = [];

						promises.push(ListService.getById("list/bankbycountry/" + newValue + "/" + this.paymode));

						// if (this.vModel.CountryId == 251) {
						promises.push(ListService.getById("list/statebycountry/" + newValue));
						// }

						promises.push(ListService.getStreetTypeByCountry(newValue));

						promises.push(ListService.get("recipient/checkIfAccountValidationRequired/" + this.vModel.CountryId + "/" + this.vModel.PayoutModeId));

						Promise.all(promises).then((response) => {
							if (response[0].body) {
								this.BankCollection = response[0].body;
								this.AllBanksList = [...this.BankCollection];
							}
							if (response[1]) {
								this.StateCollection = response[1].body;
							}
							if (response[2]) {
								this.StreetTypeCollection = response[2].body;
							}
							if (response[3]) {
								this.IsAccountValidationRequired = response[3].body;
							}
						});
					} else if (this.paymode == "2" || this.paymode == "34" || this.paymode == "35") {
						var promises = [];
						promises.push(
							ListService.getById(
								"list/agentbycountry/" +
								this.vModel.CountryId +
								"/" +
								this.paymode
							)
						);

						Promise.all(promises).then((response) => {
							if (response[0].body) {
								this.AgentCollection = response[0].body;
							}
						});
					}
				}
			},

			"onbehalfRelatedModel.isOnBehalfTransaction": function (newpp, oldpp) {
				if (!newpp) {
					this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId = null;
					this.onbehalfRelatedModel.OnBehalfDetail.Name = null;
					this.onbehalfRelatedModel.OnBehalfDetail.IdNumber = null;

				} else {
					//if (this.visaStatus == '') {
					if (!this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList && this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId == null) {
						var promises = [];
						promises.push(ListService.getOnBehalfList(this.vModel.PayoutModeId));
						Promise.all(promises).then(resp => {
							this.onbehalfRelatedModel.OnBehalfList = resp[0].body;
							this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
						})
					}
				}
			}
		},

        computed: {
            accountMask: function () {
                if (this.vModel.CountryId == "23") return "######-#########";
                else if (this.vModel.CountryId == "172") return "##-####-#######-###";
                else if (this.vModel.CountryId == "250") return "######-##########";
                else if (this.vModel.CountryId == "251")
                    return "#########-#################";
                else return "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
            },
            fullname: function () {
                if (this.vModel.FirstName == null) this.vModel.FirstName = "";

				if (this.vModel.MiddleName == null) this.vModel.MiddleName = "";

				if (this.vModel.LastName == null) this.vModel.LastName = "";

				return (
					this.vModel.FirstName.trim() +
					this.vModel.MiddleName.trim() +
					this.vModel.LastName.trim()
				);
			},
			walletName: function () {
				if (this.vModel.PayoutModeId == 22) {
					return `${this.vModel.FirstName} ${this.vModel.LastName}`;
				}
			},

			onBankDropDownBound: function (e) {

				if (this.vModel.PayoutModeId == 1) {
					if (this.vModel.BankId) {
						var promises = [];
						promises.push(

							ListService.getAccountValidation(this.vModel.CountryId, this.vModel.PayoutModeId, this.vModel.BankId)
						);

						Promise.all(promises).then(response => {
							this.accountNoValidation = response[0].body;
							if (response[0].body.IsAccValidationActive)
								this.vModel.AccountNumber = this.accountNumber.replace(/-/g, '');
						});
					}
				}

				if (
					this.FieldValidation != null &&
					this.FieldValidation.BranchId != null
				) {
					var banks = this.BankCollection.filter((s) => {
						return s.Id == this.vModel.BankId;
					});
					if (this.vModel.BankId && banks.length > 0) {
						var promises = [];
						promises.push(
							ListService.getById("list/branchbybank/" + this.vModel.BankId)
						);
						Promise.all(promises).then((response) => {
							if (response[0].body) {
								this.$refs.branchdropdownlist
									.kendoWidget()
									.setDataSource(response[0].body);
								this.$refs.branchdropdownlist
									.kendoWidget()
									.value(this.vModel.BranchId);

								if (response[0].body.length == 1) {
									this.vModel.BranchId = response[0].body[0].Id;
									this.$refs.branchdropdownlist
										.kendoWidget()
										.value(this.vModel.BranchId);
								} else if (response[0].body.length == 0) {
									this.vModel.BranchId = null;
								}
							}
						});
					}
				}

			},
			onStateDropDownBound: function (e) {
				var self = this;
				if (self.FieldValidation != null && self.FieldValidation.CityId != null) {
					if (self.vModel.StateId) {
						if (
							self.vModel.CountryId == "23" &&
							self.vModel.PayoutModeId == "1"
						) {
							self.selectedState = self.StateCollection.filter((p) => {
								return p.Id == self.vModel.StateId;
							})[0];

							if (self.selectedState.Cities.length > 0) {
								self.$refs.citydropdownlist
									.kendoWidget()
									.setDataSource(self.selectedState.Cities);
							}
							if (self.vModel.CityId) {
								self.$refs.citydropdownlist
									.kendoWidget()
									.value(self.vModel.CityId);
							}
						}
					}
				}
			},

			onBranchDropDownBound: function (e) {
				if (this.vModel.BranchId) {
					var promises = [];
					promises.push(
						ListService.getById(
							"recipient/branchcodebybranch/" + this.vModel.BranchId
						)
					);

					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.vModel.BranchCode = response[0].body.BranchCode;
						}
					});
				}
			},
			onAgentDropDownBound: function (e) {
				if (this.vModel.AgentId) {
					var promises = [];
					promises.push(
						ListService.getById("recipient/remarkbyagent/" + this.vModel.AgentId)
					);
					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.Remarks = response[0].body.Remarks;
							this.Note = response[0].body.Note;
							this.GroupCode = response[0].body.GroupCode;
						}
					});
				}
			},
		},
		methods: {
			onSearch(search, loading) {
				loading(true);
				this.search(loading, search, this);
			},
			search: _.debounce((loading, search, vm) => {
				vm.$http
					.post("list/branchbybank", {
						query: unescape(search),
						bankid: vm.vModel.BankId,
					})
					.then(
						(response) => {
							vm.optionBranches = response.body;
							loading(false);
						},
						(error) => {
							loading(false);
						}
					);
			}, 350),
			onChangePayoutGroup: function () {
				var dropDownList = this.$refs.payoutagentdropdownlist.kendoWidget();
				var selectedText = dropDownList.text();

				if (selectedText) {
					this.vModel.PayoutGroupName = selectedText;

					if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 21 && this.vModel.PayoutGroupName == 'UNIONPAY TERRAPAY') {
						this.IsUnionpayBtnDisabled = true;
					}
					else {
						this.IsUnionpayBtnDisabled = false;
					}
				}
			},
			onChangeCountryDropDown: function () {
				var dropDownList = this.$refs.countrydropdownlist.kendoWidget();
				var selectedValue = dropDownList.value();

				if (selectedValue) {
					var county = this.CountryCollection.filter((e) => {
						return e.Id == selectedValue;
					});

					this.$refs.paymodedropdownlist
						.kendoWidget()
						.setDataSource(county[0].CountyPayouts);

					this.FlagCode = county[0].FlagCode;
				}
			},
			onChangeBankDropDown: function () {
				var dropDownList = this.$refs.bankdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				var selectedText = dropDownList.text();

				if (this.vModel.PayoutModeId == 1) {
					if (selectedVlaue) {
						var promises = [];
						promises.push(

							ListService.getAccountValidation(this.vModel.CountryId, this.vModel.PayoutModeId, selectedVlaue)
						);

						Promise.all(promises).then(response => {
							this.accountNoValidation = response[0].body;
						});
					}
				}

				if (this.FieldValidation != null && this.FieldValidation.BranchId != null) {
					this.selectedBranch = null;
					this.optionBranches = [];
					if (this.vModel.CountryId == 2) {
						this.vModel.BranchCode = null;
						this.IfscCode = null;
						return;
					}

					if (selectedVlaue) {
						var promises = [];
						promises.push(
							ListService.getById("list/branchbybank/" + selectedVlaue)
						);

						Promise.all(promises).then((response) => {
							if (response[0].body) {
								this.$refs.branchdropdownlist
									.kendoWidget()
									.setDataSource(response[0].body);

								if (response[0].body.length == 1) {
									this.vModel.BranchId = response[0].body[0].Id;
								} else if (response[0].body.length == 0) {
									this.vModel.BranchId = null;
								}
							}
						});
					}
				}

				if (this.vModel.CountryId == 6 && this.vModel.PayoutModeId == 24) {
					this.showGcashAccountPrefix = false;
					if (selectedText.toUpperCase() == 'GCASH') {
						this.showGcashAccountPrefix = true;
						this.vModel.AccountPrefix = '09';
					}
				}
			},
			onChangeAgentDropDown: function () {
				var dropDownList = this.$refs.agentdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();

				if (selectedVlaue) {
					var promises = [];
					promises.push(
						ListService.getById("recipient/remarkbyagent/" + selectedVlaue)
					);

					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.Remarks = response[0].body.Remarks;
							this.Note = response[0].body.Note;
						}
					});
				}
			},
			onChangeBranchDropDown: function () {
				var dropDownList = this.$refs.branchdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();

				if (selectedVlaue) {
					var promises = [];
					promises.push(
						ListService.getById("recipient/branchcodebybranch/" + selectedVlaue)
					);

					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.vModel.BranchCode = response[0].body.BranchCode;
						}
					});
				}
			},

			onSubmit: function () {
				if (this.isOnSecondPage == false && this.vModel.Id == null) {
					this.$validator.validateAll().then((result) => {
						if (result) {
							this.getNextFormData();
							this.isOnSecondPage = true;
						}
					});
				} else {
					if (this.isProcessing) return false;
					this.$validator.validateAll().then((result) => {
						if (result) {
							this.redirectToOnbehalf = false;

							if (this.vModel.TransactionRefNo && !this.TransactionDetail.OnBehalfCustomerDetail.OnBehalfCustomerId && !this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId) {
								var selectedVlaue = this.vModel.RelationshipId;
								var additionalRelationship = ["7", "8", "15", "16", "17"];
								if (additionalRelationship.includes(selectedVlaue) || this.additionalRelationshipCollection.includes(selectedVlaue)) {
									this.redirectToOnbehalf = true;
								}
							}
							if (this.redirectToOnbehalf) {
								if (!this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList && this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId == null) {
									var promises = [];
									promises.push(ListService.getOnBehalfList(this.vModel.PayoutModeId));
									Promise.all(promises).then(resp => {
										this.onbehalfRelatedModel.OnBehalfList = resp[0].body;
										this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
										this.showOnbehalfDetail = true;
									})
								}
								//this.onbehalfRelatedModel.isOnBehalfTransaction = false;
								//this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
								kendo.alert("Please provide the details of the person you're sending on behalf of");
								return false;
							}

							var url = "";
							if (this.vModel.Id) {
								url = this.url.update;
							} else {
								url = this.url.add;
							}
							var post = Object.assign({}, this.vModel);
							if (this.vModel.CountryId == 23 && this.vModel.PayoutModeId == 1)
								post.MobileContact = `+61${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 123 && this.vModel.PayoutModeId == 1)
								post.MobileContact = `+81${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 114 && this.vModel.PayoutModeId == 1)  //Hong Kong
								post.MobileContact = `+852${this.vModel.MobileContact}`;
							if (this.vModel.CountryId == 1 && (this.vModel.PayoutModeId == 23 ||  this.vModel.PayoutModeId == 30))
								post.AccountNumber = `+88${this.vModel.AccountNumber}`;
							if (this.vModel.CountryId == 56 && this.vModel.PayoutModeId == 27)
								post.AccountNumber = `+${this.vModel.AccountNumber}`;
							if (this.vModel.CountryId == 3 && this.vModel.PayoutModeId == 28) {
								if (this.vModel.AccountPrefix != undefined)
									post.AccountNumber = this.vModel.AccountPrefix + this.vModel.AccountNumber;
							}
							if (this.vModel.CountryId == 6 && this.vModel.PayoutModeId == 24 && this.vModel.BankName.toUpperCase() == 'GCASH') {
								post.AccountPrefix = "09";
								post.AccountNumber = "09" + this.vModel.AccountNumber;
							}
							this.isProcessing = true;

							if (this.vModel.PayoutModeId == 22) {
								TransactionService.validateAlipay({
									FirstName: this.vModel.FirstName,
									LastName: this.vModel.LastName,
									AccountNumber: this.vModel.AccountNumber,
									PayoutAmount: this.vModel.TransactionRefNo
										? this.TransactionDetail.PayoutAmount
										: 1.0,
								}).then(
									(res) => {
										if (res.body.IsValid) {
											this.$http.post(url, post).then(
												(response) => {
													if (this.vModel.Id) {
														this.$toastr("success", "Updated Successfully");
													} else {
														this.$toastr("success", "Created Successfully");
													}

													if (this.vModel.TransactionRefNo && !this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId)
														this.$router.push(
															"/transaction/reprocess/" +
															this.vModel.TransactionRefNo
														);
													else if (this.vModel.TransactionRefNo && this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId)
														this.$router.push(
															"/transaction/reprocess/" +
															this.vModel.TransactionRefNo + "/" + this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId
														);
													else if (
														this.fromPath == "/transaction" &&
														this.vModel.TransactionRefNo == null
													)
														this.$router.push("/transaction");
													else this.$router.push("/recipient");
													this.isProcessing = false;
												},
												(error) => {
													this.isProcessing = false;
												}
											);
										} else {
											this.$toastr("error", res.body.Message);
										}
										this.isProcessing = false;
									},
									(error) => {
										this.isProcessing = false;
									}
								);
							} else {
								this.$http.post(
									url,
									post,
									{
										headers: {
											"Handle-Invalid-P2P-Name": "true"
										}
									}).then(
									(response) => {
										if (this.vModel.Id) {
											this.$toastr("success", "Updated Successfully");
										} else {
											this.$toastr("success", "Created Successfully");
										}

										if (this.vModel.TransactionRefNo && !this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId)
											this.$router.push(
												"/transaction/reprocess/" +
												this.vModel.TransactionRefNo
											);
										else if (this.vModel.TransactionRefNo && this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId)
											this.$router.push(
												"/transaction/reprocess/" +
												this.vModel.TransactionRefNo + "/" + this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId
											);
										else if (
											this.fromPath == "/transaction" &&
											!this.vModel.TransactionRefNo
										)
											this.$router.push("/transaction");
										else this.$router.push("/recipient");
										this.isProcessing = false;
									},
									(error) => {
										this.isProcessing = false;

										if (error.body && error.body.length > 0 && error.body[0].Message === "Invalid Receiver name for Personal Receiver Type.") {
											this.PendingReceiverFullName = `${this.vModel.FirstName} ${this.vModel.LastName}`.trim();
											this.ShowReceiverTypePopup = true;
											return;
										}
									}
								);
							}
						}
					});
				}
			},

			getNextFormData: function () {
				if (
					this.vModel.PayoutModeId == 1 ||
					this.vModel.PayoutModeId == 21 ||
					this.vModel.PayoutModeId == 22
				) {
					this.vModel.PayModeName =
						this.vModel.PayoutModeId == 1
							? "Bank Account"
							: this.vModel.PayoutModeId == 21
								? "Union Pay Card"
								: "Alipay";
					var promises = [];
					promises.push(
						ListService.getById(
							"recipient/countrydetailbycountry/" + this.vModel.CountryId
						)
					);

					promises.push(ListService.getRelationship(this.vModel.PayoutModeId, this.vModel.CountryId));

					if (this.vModel.CountryId == 251 || this.vModel.CountryId == 23) {
						promises.push(
							ListService.getById("list/statebycountry/" + this.vModel.CountryId)
						);
					}

					if (this.vModel.CountryId != 56)
						promises.push(
							ListService.getById("list/bankbycountry/" + this.vModel.CountryId)
						);

					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.vModel.FlagCode = response[0].body.FlagCode;
							this.vModel.CountryName = response[0].body.CountryName;
						}

						if (response[1].body) {
							this.RelationshipCollection = response[1].body;
						}

						if (this.vModel.CountryId == 251 || this.vModel.CountryId == 23) {
							this.StateCollection = response[2].body;
						}

						this.BankCollection =
							response[
								this.vModel.CountryId == 251 || this.vModel.CountryId == 23
									? 3
									: 2
							].body;
					});
				} else if (this.vModel.PayoutModeId == 2) {
					this.vModel.PayModeName = "Cash Pickup";
					var promises = [];
					promises.push(
						ListService.getById(
							"recipient/countrydetailbycountry/" + this.vModel.CountryId
						)
					);
					promises.push(
						ListService.getById(
							"list/agentbycountry/" +
							this.vModel.CountryId +
							"/" +
							this.vModel.PayoutModeId
						)
					);
					promises.push(ListService.getRelationship(this.vModel.PayoutModeId, this.vModel.CountryId));

					Promise.all(promises).then((response) => {
						if (response[0].body) {
							this.vModel.FlagCode = response[0].body.FlagCode;
							this.vModel.CountryName = response[0].body.CountryName;
						}
						if (response[1].body) {
							this.AgentCollection = response[1].body;
						}
						if (response[2].body) {
							this.RelationshipCollection = response[2].body;
						}
					});
				}
			},

			onCancel: function () {
				this.$router.push("/recipient/merchantrade");
			},

			onChangeState: function () {
				var self = this;
				self.vModel.CityId = null;
				var dropDownList = self.$refs.statedropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();

				if (selectedVlaue) {
					if (
						self.vModel.CountryId == "23" &&
						self.vModel.PayoutModeId == "1" &&
						self.vModel.StateId != ""
					) {
						self.selectedState = self.StateCollection.filter((p) => {
							return p.Id == selectedVlaue;
						})[0];

						if (self.selectedState.Cities.length > 0) {
							setTimeout(function () {
								self.$refs.citydropdownlist
									.kendoWidget()
									.setDataSource(self.selectedState.Cities);
							}, 1000);
						}
					}
				}
			},

			onFormClear: function () {
				var self = this;
				Object.keys(self.vModel).forEach(function (key, index) {
					if (
						key != "Id" &&
						key != "CountryId" &&
						key != "PayoutModeId" &&
						key != "CountryName" &&
						key != "FlagCode"
					)
						self.vModel[key] = null;
				});
			},
			onChangeIfscCode: function () {
				var model = {
					IFSC: this.vModel.BranchCode,
				};
				this.$http.post("list/branch/ifsc", model).then((response) => {
					this.vModel.BranchId = response.body.Id;
					this.vModel.BankId = response.body.BankId;
					this.vModel.BranchName = response.body.BranchName;
					this.vModel.BranchAddress = response.body.Address;
					this.IfscCode = this.vModel.BranchCode;

					this.selectedBranch =
						response.body.BranchName != null
							? {
								Id: this.vModel.BranchId,
								Text: this.vModel.BranchName,
								Address: this.vModel.BranchAddress,
								BranchCode: this.vModel.BranchCode,
							}
							: null;
				});
			},
			onChangeRelationship: function (e) {
				var dropDownList = this.$refs.relationshipdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				var additionalRelationship = ["7", "8", "15", "16", "17"];
				if (additionalRelationship.includes(selectedVlaue)) {
					this.showAdditionalRelationshipMessage = true;
				} else
					this.showAdditionalRelationshipMessage = false;
				this.vModel.RelationshipId = selectedVlaue;	
				if (this.vModel.TransactionRefNo && !this.TransactionDetail.OnBehalfCustomerDetail.OnBehalfCustomerId && !this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId) {
					if (additionalRelationship.includes(selectedVlaue)) {
						this.onbehalfRelatedModel.isOnBehalfTransaction = false;
						this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = true;
					}
				}

			},
			onRelationshipBound: function (e) {
				var dropDownList = this.$refs.relationshipdropdownlist.kendoWidget();
				var selectedVlaue = dropDownList.value();
				var additionalRelationship = ["7", "8", "15", "16", "17"];
				if (additionalRelationship.includes(selectedVlaue)) {
					this.showAdditionalRelationshipMessage = true;
				} else
					this.showAdditionalRelationshipMessage = false;

				if (this.mode == "edit" && this.vModel.ReceiverTypeId) {
					var restrictedCountries = [2, 5, 3, 6, 8, 9, 235, 123, 114, 251, 23];

					if (restrictedCountries.includes(Number(this.vModel.CountryId))) {
						if (this.RelationshipCollection && this.RelationshipCollection.length > 0 && dropDownList.dataSource.data().length == this.RelationshipCollection.length) {

							this.IndiaRelationshipCollection = this.RelationshipCollection.filter(item =>
								item.ReceiverTypeId == this.vModel.ReceiverTypeId
							);

							dropDownList.setDataSource(this.IndiaRelationshipCollection);
						}
					}
				}
			},
			onViewDocument: function (img) {
				var newWind = window.open("");
				var image = new Image();
				image.src = "data:image/jpg;base64," + img;
				newWind.document.write(image.outerHTML);
			},
			verifybKash: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: "+88" + this.vModel.AccountNumber
				};
				this.IsBkashVerify = true;
				this.$http.post("v2/transaction/validate/bkash", model).then(
					response => {
						console.log(response);
						this.BKashFirstName = response.body.FirstName;
						this.BkashLastName = response.body.LastName;
						this.BkashReceiverName = response.body.FullName;

						if (response.body.IsValid == true) {
							if (response.body.IsNameMatched == true) {
								this.IsBkashBtnDisabled = false;
								this.IsValidBkashNumber = true;
							}
							else {
								this.IsValidBkashNumber = false;
								this.IsBkashBtnDisabled = true;
								this.ShowBkashNameMismatchPopup = true;
							}
						} else {
							this.IsValidBkashNumber = false;
							this.IsBkashBtnDisabled = true;
						}
					},
					error => {
						this.IsValidBkashNumber = false;
						this.IsBkashBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsBkashVerify = false;

			},
			verifyUnionpay: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Unionpay Card Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					ReceiverPhoneNo: this.vModel.MobileContact
				};
				this.$http.post("v2/transaction/validate/unionpay", model).then(
					response => {
						this.IsUnionpayVerify = true;
						if (response.body.IsValid == true) {
							this.IsValidUnionpayCardNumber = true;
							this.IsUnionpayBtnDisabled = false;
						} else {
							this.IsValidUnionpayCardNumber = false;
							this.IsUnionpayBtnDisabled = true;
						}
					},
					error => {
						this.IsValidUnionpayCardNumber = false;
						this.IsUnionpayBtnDisabled = true;
					}

				);
			},
			handleYes: function () {
				this.IsValidBkashNumber = true;
				this.IsBkashBtnDisabled = false;
				this.vModel.FirstName = this.BkashReceiverName;
				this.vModel.LastName = this.BkashLastName;
				this.ShowBkashNameMismatchPopup = false;
			},

			handleNo: function () {
				this.IsValidBkashNumber = true;
				this.ShowBkashNameMismatchPopup = false;
			},

			verifyMCB: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				} else if (this.vModel.LastName == "") {
					kendo.alert("Please Enter Last Name.");
					return;
				} else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber
				};
				this.IsMCBVerify = true;
				this.$http.post("v2/transaction/validate/mcb", model).then(
					response => {
						console.log(response);
						this.MCBFirstName = response.body.FirstName;
						this.MCBLastName = response.body.LastName;
						if (response.body.IsValid == true) {
							this.IsMCBBtnDisabled = false;
							this.IsValidMCBNumber = true;
						} else {
							this.IsValidMCBNumber = false;
							this.IsMCBBtnDisabled = true;
							this.ShowMCBNameMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidMCBNumber = false;
						this.IsMCBBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsMCBVerify = false;
			},
			ValidateCommonwalletnumber: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				}
				else if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					PayoutModeId: this.vModel.PayoutModeId
				};
				this.IsBkashVerify = true;
				this.$http.post("v2/transaction/validate/walletnumber", model).then(
					response => {
						console.log(response);
						this.BKashFirstName = response.body.FirstName;
						this.BkashLastName = response.body.LastName;
						this.BkashReceiverName = response.body.FullName;
						if (response.body.IsValid == true) {
							this.IsBkashBtnDisabled = false;
							this.IsValidBkashNumber = true;
							
						} else {
							this.IsValidBkashNumber = false;
							this.IsBkashBtnDisabled = true;
							//this.ShowBkashNameMismatchPopup = true;
						}
					},
					error => {
						this.IsValidBkashNumber = false;
						this.IsBkashBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsBkashVerify = false;
			},
			handleYesMCB: function () {
				this.IsValidMCBNumber = true;
				this.IsMCBBtnDisabled = false;
				this.vModel.FirstName = this.MCBFirstName;
				this.vModel.LastName = this.MCBLastName;
				this.ShowMCBNameMismatchPopup = false;
			},

			handleNoMCB: function () {
				this.IsValidMCBNumber = true;
				this.ShowMCBNameMismatchPopup = false;
			},
			handleClose: function () {
				this.IsWingWalletBtnDisabled = true;
				this.ShowWingWalletCurrencyMismatchPopup = false;
				this.$refs['modal-wingwalletmismatch'].hide()
			},
			verifyWingWalletNumber: function () {
				if (this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Wallet Number.");
					return;
				}
				var model = {
					WingWalletNumber: this.vModel.AccountNumber,
					CurrencyId: this.vModel.CurrencyId
				};
				this.IsWingWalletVerify = true;
				this.$http.post("v2/transaction/validate/wingWalletNumber", model).then(
					response => {
						this.IsWingWalletValidationChecked = true;
						console.log(response);
						this.WingWalletFullName = response.body.FullName;
						this.WingWalletCurrency = response.body.ReceiverCurrency;
						if (response.body.IsValid == true) {
							this.IsWingWalletBtnDisabled = false;
							this.IsValidWingWalletNumber = true;
						} else {
							this.IsWingWalletBtnDisabled = true;
							this.IsValidWingWalletNumber = false;
							this.ShowWingWalletCurrencyMismatchPopup = true;
							//kendo.alert(response.body.Message);
						}

					},
					error => {
						this.IsValidWingWalletNumber = false;
						this.IsWingWalletBtnDisabled = true;
						// kendo.alert(error.body[0].Message);
						// return;
					}

				);
				this.IsWingWalletVerify = false;
			},
			onChangeReceiverType: function () {
				var dropDownList = this.$refs.receivertypedropdownlist.kendoWidget();
				var selectedReceiverTypeId = dropDownList.value();

				if (selectedReceiverTypeId) {
					this.vModel.RelationshipId = null;
					//if (selectedReceiverTypeId == 1) {
					//	this.vModel.CompanyName = null;
					//}
					//else if (selectedReceiverTypeId == 2) {
					//	this.vModel.FirstName = null;
					//	this.vModel.LastName = null;
					//	this.vModel.CompanyTypeId = null;
					//}
					this.vModel.ReceiverTypeId = selectedReceiverTypeId;


					if (this.vModel.CountryId == 2 || this.vModel.CountryId == 5 || this.vModel.CountryId == 3 || this.vModel.CountryId == 6 || this.vModel.CountryId == 8 || this.vModel.CountryId == 9 || this.vModel.CountryId == 235 || this.vModel.CountryId == 123 || this.vModel.CountryId == 114 || this.vModel.CountryId == 23 || this.vModel.CountryId == 251) {
						if (this.RelationshipCollection && this.RelationshipCollection.length > 0) {

							this.IndiaRelationshipCollection = this.RelationshipCollection.filter(item =>
								item.ReceiverTypeId == selectedReceiverTypeId
							);
							var relationshipDropdown = this.$refs.relationshipdropdownlist;
							if (relationshipDropdown && relationshipDropdown.kendoWidget) {
								relationshipDropdown.kendoWidget()
									.setDataSource(this.IndiaRelationshipCollection);
							}
						}
					}

					this.relationshipDropdownKey += 1;

					this.$nextTick(() => {
						var relationshipDropdown = this.$refs.relationshipdropdownlist;
						if (relationshipDropdown && relationshipDropdown.kendoWidget) {
							var targetDataSource = (this.vModel.CountryId == 2 || this.vModel.CountryId == 5 || this.vModel.CountryId == 3 || this.vModel.CountryId == 6 || this.vModel.CountryId == 8 || this.vModel.CountryId == 9 || this.vModel.CountryId == 235 || this.vModel.CountryId == 123 || this.vModel.CountryId == 114 || this.vModel.CountryId == 23 || this.vModel.CountryId == 251)
								? this.IndiaRelationshipCollection
								: this.RelationshipCollection;

							relationshipDropdown.kendoWidget().setDataSource(targetDataSource);
						}
					});
				}
			},
			onRemoveOnBehalfCustomer: function () {
				this.onbehalfRelatedModel.OnBehalfDetail.OnBehalfCustomerId = null;
				this.onbehalfRelatedModel.isOnBehalfTransaction = false;
				this.onbehalfRelatedModel.onBehalfDecisionCheck.ShowOnbehalfList = false;
			},


			verifyIndonesiaBankAccount: function () {
				if (this.vModel.FirstName == "") {
					kendo.alert("Please Enter First Name.");
					return;
				}
				else if (this.vModel.AccountNumber == null || this.vModel.AccountNumber == "") {
					kendo.alert("Please Enter Account Number.");
					return;
				}
				else if (this.vModel.BankId == null || this.vModel.BankId == "") {
					kendo.alert("Please select a Bank.");
					return;
				}
				var model = {
					FirstName: this.vModel.FirstName,
					LastName: this.vModel.LastName,
					AccountNumber: this.vModel.AccountNumber,
					BankId: this.vModel.BankId
				};
				this.IsIndonesiaVerify = true;
				this.$http.post("v2/transaction/validate/indonesiabankaccount", model).then(
					response => {
						console.log(response);
						this.IndonesiaAccountFirstName = response.body.FirstName;
						this.IndonesiaAccountLastName = response.body.LastName;
						this.IndonesiaAccountReceiverName = response.body.FullName;
						if (response.body.IsValid == true) {
							if (response.body.IsNameMatched == true) {
								this.IsIndonesiaBankAccBtnDisabled = false;
								this.IsValidIndonesiaAccNumber = true;
							}
							else {
								this.IsValidIndonesiaAccNumber = false;
								this.IsIndonesiaBankAccBtnDisabled = true;
								this.ShowIndonesiaAccountMismatchPopup = true;
							}
						} else {
							this.IsValidIndonesiaAccNumber = false;
							this.IsIndonesiaBankAccBtnDisabled = true;
						}
					},
					error => {
						this.IsValidIndonesiaAccNumber = false;
						this.IsIndonesiaBankAccBtnDisabled = true;
					}

				);
				this.IsIndonesiaVerify = false;
			},
			handleYesForIndonesiaAcc: function () {
				this.IsValidIndonesiaAccNumber = true;
				this.IsIndonesiaBankAccBtnDisabled = false;
				this.vModel.FirstName = this.IndonesiaAccountFirstName;
				this.vModel.LastName = this.IndonesiaAccountLastName;
				this.ShowIndonesiaAccountMismatchPopup = false;
			},
			handleNoForIndonesiaAcc: function () {
				this.IsValidIndonesiaAccNumber = true;
				this.ShowIndonesiaAccountMismatchPopup = false;
			},
			DeActivateSaveButton() {
				if (this.vModel.PayoutModeId == 1 && this.vModel.CountryId == 3) {
					this.IsIndonesiaBankAccBtnDisabled = true;
				}
			},
			handleReceiverTypeYes() {
				this.vModel.CompanyName = this.PendingReceiverFullName;
				this.vModel.FirstName = "";
				this.vModel.LastName = "";
				this.vModel.ReceiverTypeId = 2;
				this.ShowReceiverTypePopup = false;

				this.$nextTick(() => {
					if (this.$refs.receivertypedropdownlist && this.$refs.receivertypedropdownlist.kendoWidget) {
						this.$refs.receivertypedropdownlist
							.kendoWidget()
							.value(2);
					}

					this.onChangeReceiverType();

					this.vModel.CompanyName = this.PendingReceiverFullName;
				});
			},

			handleReceiverTypeNo() {
				this.vModel.FirstName = "";
				this.vModel.LastName = "";
				this.ShowReceiverTypePopup = false;
			}
		}
	}
</script>
<style>
	.dropdown.v-select.single.searchable.input.bank-branch input[type="search"] {
		border: 0;
	}

	.dropdown.v-select.single.searchable.input.bank-branch .dropdown-toggle::after {
		display: none;
	}

	.form-card-header {
		padding: 0px 15px 75px 15px !important;
	}

		.form-card-header img {
			float: right;
			height: 75px;
		}

		.form-card-header h3 {
			float: left;
			height: 75px;
			padding-top: 25px;
		}

	.red-btn {
		background-color: #d5080f;
		color: #fff;
	}

	.right-option button:disabled .btn-content,
	button[disabled] {
		border: 1px solid #cccccc;
		background-color: #cccccc;
		color: #fff;
	}

	.right-option button:disabled .right-icon,
	button[disabled] {
		border: 1px solid #777171;
		background-color: #777171;
		color: #fff;
	}
</style>
